import { useEffect, useRef } from "react";


const useWillMount = callback => {
    const mounted = useRef(false);
    if (!mounted.current) callback();

    useEffect(() => {
        mounted.current = true;
    }, []);
};

export default useWillMount;